import React from 'react';
import get from 'lodash/get';
import { Tag } from 'antd';

const colors = {
  Running: '#73d13d',
  Completed: '#bfbfbf',
  Scheduled: '#ffa940',
  'In Review': '#ffa940',
  Paused: '#ff4d4f',
  Archived: '#bfbfbf',
};

const TheTag = ({ resultLabel }) => (
  <Tag color={get(colors, resultLabel, colors.Completed)}>{resultLabel}</Tag>
);

export const StatusLabel = ({ record, status }) => {
  let resultLabel = status && status.split(',').map(a => a.trim());

  if (!resultLabel && record) {
    const { end_date, start_date, status: statusId, approval_status } = record;

    const completed = Date.parse(end_date) - Date.parse(new Date()) < 0;
    const scheduled = Date.parse(start_date) - Date.parse(new Date()) > 0;

    let status1 = 'Running';
    if (completed) status1 = 'Completed';
    if (scheduled) status1 = 'Scheduled';

    const statusLabels = { 1: status1, 2: 'Paused', 3: 'Archived' };
    const intStatus = parseInt(statusId, 10);
    resultLabel = get(statusLabels, intStatus, false);

    if (approval_status === 'Submitted') resultLabel = 'Submitted';
    if (approval_status === 'In Review') resultLabel = 'In Review';
  }

  return Array.isArray(resultLabel) ? (
    resultLabel.map(a => <TheTag resultLabel={a} />)
  ) : (
    <TheTag resultLabel={resultLabel} />
  );
};
